import { render, staticRenderFns } from "./Consume.vue?vue&type=template&id=626e13c7&lang=pug"
import script from "./Consume.vue?vue&type=script&lang=js"
export * from "./Consume.vue?vue&type=script&lang=js"
import style0 from "./Consume.vue?vue&type=style&index=0&id=626e13c7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports